import React from 'react';

export type TAutoFocusProps<T extends HTMLElement> = {
  ref: React.RefCallback<T>;
  tabIndex: 0;
};

const useAutoFocus = <T extends HTMLElement>(): TAutoFocusProps<T> => {
  const [element, setRef] = React.useState<T | null>(null);

  React.useEffect(() => {
    if (element !== null) {
      element.focus();
    }
  }, [element]);

  return {ref: setRef, tabIndex: 0};
};

export default useAutoFocus;
